import { createStyles, Stack, Timeline } from '@mantine/core';
import type { PolicyViolationOut } from '@repo/api-codegen';
import { useApiListResourceLogs } from '@repo/api-codegen';
import { Text } from '@repo/foundations';
import { IssueActivityLog } from './IssueActivityLog';
import { IssueActivityLogIcon } from './IssueActivityLogIcon';

const useStyles = createStyles((theme) => ({
	timeline: {
		paddingLeft: 0,
	},
	item: {
		paddingLeft: theme.spacing.md,
		'::before': {
			top: `calc(20px + ${theme.spacing['3xs']})`,
			bottom: `calc((${theme.spacing.md} - ${theme.spacing['3xs']}) * -1)`,
			borderColor: theme.other.getColor('border/primary/default'),
			borderWidth: 1,
		},
	},
	itemBullet: {
		'&[data-with-child]': {
			backgroundColor: theme.other.getColor('fill/primary/default'),
			border: 'none',
		},
	},
}));

function IssueActivity({ policyResult }: { policyResult: PolicyViolationOut }) {
	const { classes } = useStyles();
	const activity = useApiListResourceLogs({
		queryParams: {
			resource_id: policyResult.id,
		},
	});

	return (
		<Stack p="xl" spacing="sm">
			<Text size="sm" fw={500}>
				Activity
			</Text>
			<Timeline lineWidth={1} classNames={classes}>
				{/* Issue started does not have an activity log, so we need to add it manually */}
				<Timeline.Item bullet={<IssueActivityLogIcon />}>
					<IssueActivityLog policyResult={policyResult} />
				</Timeline.Item>
				{activity.data &&
					activity.data.non_versioned_logs.length > 0 &&
					activity.data.non_versioned_logs
						.sort(
							(a, b) =>
								new Date(a.logged_at).getTime() -
								new Date(b.logged_at).getTime()
						)
						.map((log) => (
							<Timeline.Item
								key={log.id}
								bullet={<IssueActivityLogIcon activityLog={log} />}
							>
								<IssueActivityLog
									policyResult={policyResult}
									activityLog={log}
								/>
							</Timeline.Item>
						))}
			</Timeline>
		</Stack>
	);
}

export default IssueActivity;
